export default __webpack_public_path__ + "static/media/notfound.83dbb33c.png";